import { render, staticRenderFns } from "./GuidelinesPhoto.vue?vue&type=template&id=25df9c7d&scoped=true&"
import script from "./GuidelinesPhoto.vue?vue&type=script&lang=js&"
export * from "./GuidelinesPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df9c7d",
  null
  
)

export default component.exports